module.exports = __webpack_public_path__ + "img/auth-success-02.761b75fc.png";